import styles from './style.module.css'
import api from "../../api";
import { useEffect, useState } from 'react'
import Moment from 'react-moment';
import 'moment/locale/ru';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PreLoader } from '../index'

import { FiDownloadCloud } from 'react-icons/fi'
import { IoDocumentText } from "react-icons/io5";
import { Link } from 'react-router-dom';

const AnnounSection = () => {
    const [loading, setLoading] = useState(false);
    const [announs, setAnnouns] = useState([])
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 3,
        autoplay: true,
        autoplaySpeed: 30000,
        pauseOnHover: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    rows: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    rows: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    rows: 1,
                }
            }
        ]
    };

    useEffect(() => {
        setLoading(true);
        api.getNews()
            .then((data) => {
                setLoading(false);
                setAnnouns(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    return (
        <div className={styles.announ__content}>
            {loading ? (
                <PreLoader />
            ) : (
                <>
                    <div className={styles.body}>
                        <Slider {...settings}>
                            {announs.results?.map((announ, i) => {
                                if (announ.is_announ) {
                                    return (
                                        <Link to={`/news/${announ.id}`}>
                                            <div key={i} className={styles.content}>
                                                <div>
                                                    {announ.tags.map((tag, i) => {
                                                        return (
                                                            <span key={i} className={styles.tags}>
                                                                {tag.name}
                                                            </span>
                                                        )
                                                    })}
                                                    <div key={i} className={styles.title}>
                                                        {announ.title}
                                                    </div>
                                                    {announ.news_document.map((doc, i) => {
                                                        return (
                                                            <span key={i} className={styles.doc}>
                                                                <a
                                                                    target='_blank'
                                                                    href={doc.file}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <span>{doc.title}</span> <FiDownloadCloud />
                                                                </a>
                                                            </span>
                                                        )
                                                    })}
                                                    {announ.link ?
                                                        <Link to={announ.link}><button className={styles.btn_more}>Подробнее</button></Link>
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                }
                            })}
                        </Slider>
                    </div>
                    <a target='blank' href='http://158.160.65.66/media/news/2024/02/05/anketa_24.doc'>
                        <div className={styles.footer__area}>
                            <div className={styles.title__name}>Заявление на вступление</div>
                            <div className={styles.icon}><IoDocumentText /></div>
                        </div>
                    </a>
                </>
            )
            }
        </div>
    );
}

export default AnnounSection;